<template>
    <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        class="chevron"
        :class="{ 'right': right,'up': up,'down': down }"
    >
        <path
            d="M11.561 11.625l3.5 4.375-1.561 1.25L9 11.624 13.5 6l1.562 1.25-3.5 4.375z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: 'Chevron',
    props: {
        up: {
            type: Boolean,
            default: false
        },
        down: {
            type: Boolean,
            default: false
        },
        right: {
            type: Boolean,
            default: false
        },
        left: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="scss">
.chevron {
    transition: transform ease-in-out 0.3s;

    &.down {
        transform: rotate(-90deg);
    }

    &.up {
        transform: rotate(90deg);
    }

    &.right {
        transform: rotate(180deg);
    }
}
</style>